import { t } from '@ankr.com/common';

export function extractMessage(
  errorResponse: unknown,
  customMessage?: string,
): string {
  if (customMessage) {
    return t(customMessage);
  }

  if (typeof errorResponse === 'string') {
    return errorResponse;
  }

  const error = errorResponse as
    | { code?: number; error?: { error?: unknown } }
    | null
    | undefined;

  if (error?.code === 4001) {
    return t('error.contract-rejected');
  }

  if (errorResponse instanceof Error) {
    return errorResponse.toString();
  }

  if (error?.error?.error instanceof Error) {
    return error.error.error.toString();
  }

  return t('error.unexpected');
}
